import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import ContentRecordForm from './ContentRecordForm';
import {
  fetchContentRecord,
  saveContentRecord,
  fetchFormDatas,
} from '../../../../../../redux/actions/contentRecordsActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../../../../helpers/notification';
import { getCurrentUser } from '../../../../../../helpers/storage';
import LoadingSpinner from '../../../../../../shared/components/LoadingSpinner';
import {
  dateFormat,
  dateISOFormat,
} from '../../../../../../helpers/dateFormat';

class EditContentRecordContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      formDatas: {
        tipoClase: [],
        tipoModalidad: [],
        tipoContenido: [],
        metodologias: [],
      },
      contentRecord: {
        id: 0,
        metodologias: [],
      },
    };
  }

  componentDidMount() {
    this.refreshFormDatas();
  }

  fetchCurrentRecord = (formDatas) => {
    const { id } = this.props;
    if (!id) {
      const mergedMetodologias = formDatas.metodologias.map(m => ({
        ...m,
        selected: false,
      }));

      this.setState({
        contentRecord: { id: 0 },
        loaded: true,
        formDatas: {
          ...formDatas,
          metodologias: mergedMetodologias,
        },
      });

      return;
    }

    fetchContentRecord(id, {
      onSuccess: (contentRecord) => {
        const selectedIds = new Set((contentRecord.metodologias || []).map(m => m.value));
        const mergedMetodologias = formDatas.metodologias.map(m => ({
          ...m,
          selected: selectedIds.has(m.value),
        }));

        this.setState({
          contentRecord,
          loaded: true,
          formDatas: {
            ...formDatas,
            metodologias: mergedMetodologias,
          },
        });
      },
      onError: (error) => {
        if (error && error.status === 404) {
          createErrorMessage('El Registros de Contenido no existe');
        } else {
          createErrorMessage('Error al intentar cargar los datos del Registros de Contenido');
        }
      },
    });
  }

  refreshFormDatas = () => {
    this.setState({ loaded: false });
    fetchFormDatas({
      onSuccess: (formDatas) => {
        this.fetchCurrentRecord(formDatas);
      },
      onError: () => {
        this.setState({
          loaded: true,
          formDatas: {
            tipoClase: [],
            tipoModalidad: [],
            tipoContenido: [],
            metodologias: [],
          },
        });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  handleSubmit = (values) => {
    const {
      canEdit,
    } = values;

    if (!canEdit) {
      return;
    }

    // 1. Fusiona el texto de "otro" de nuevo en el array de metodologías
    const updatedMetodologias = (values.metodologias || []).map((m) => {
      const itemValue = values[`metodologia_otro_${m.value}`];
      // Crea un nuevo objeto para evitar mutar el estado de redux-form
      const newMetodologia = { ...m };
      if (itemValue) {
        newMetodologia.item = itemValue;
      }
      return newMetodologia;
    });

    const { subjectPeriodId, profesoresMateria } = this.props;
    const { id } = getCurrentUser();

    const profesor = profesoresMateria.find(pm => pm.value === id);

    const params = {
      id: values.id,
      profesorId: profesor.parentId,
      profesorContenidoId: values.profesorContenido.value,
      cronogramaClasesId: values.cronogramaClasesId,
      materiaPeriodoId: subjectPeriodId,
      fecha: values.fecha,
      tipoClase: values.tipoClase.value,
      modalidad: values.modalidad.value,
      contenidos: values.contenidos,
      metodologias: updatedMetodologias.filter(m => m.selected),
      tiposContenidos: (values.tiposContenidos || []).filter(m => m.value).map(m => m.value),
      unidad: values.unidad,
    };

    saveContentRecord(params, {
      onSuccess: () => {
        createSuccessMessage('Registros de Contenido guardado exitosamente');
        const { onCancel } = this.props;
        onCancel();
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else if (typeof error === 'object' && error !== null) {
          const validationMessages = Object.values(error)
            .filter(v => Array.isArray(v))
            .flat();

          if (validationMessages.length > 0) {
            validationMessages.forEach(message => createWarningMessage(message));
          } else {
            createErrorMessage('Error al intentar guardar el Registros de Contenido');
          }
        } else {
          createErrorMessage('Error al intentar guardar el Registros de Contenido');
        }
      },
    });
  }

  handleChanges = ({ value, selected }) => {
    this.setState((prevState) => {
      const newMetodologias = prevState.formDatas.metodologias.map((m) => {
        if (m.value === value) {
          return { ...m, selected };
        }
        return m;
      });

      const newSelectedValues = newMetodologias
        .filter(m => m.selected);

      return {
        formDatas: {
          ...prevState.formDatas,
          metodologias: newMetodologias,
        },
        contentRecord: {
          ...prevState.contentRecord,
          metodologias: newSelectedValues,
        },
      };
    });
  }

  handleChangeText = ({ name, value, metodologiaValue }) => {
    if (!metodologiaValue) {
      this.setState(prevState => ({
        contentRecord: {
          ...prevState.contentRecord,
          [name]: value,
        },
      }));
      return;
    }

    this.setState((prevState) => {
      const newMetodologias = prevState.formDatas.metodologias.map((m) => {
        if (m.value === metodologiaValue && m.selected) {
          return { ...m, item: value };
        }
        return m;
      });

      const newSelectedValues = newMetodologias.filter(m => m.selected);

      return {
        formDatas: {
          ...prevState.formDatas,
          metodologias: newMetodologias,
        },
        contentRecord: {
          ...prevState.contentRecord,
          metodologias: newSelectedValues,
        },
      };
    });
  }

  handleChangeSelect = (option) => {
    const optionValue = !option.isMulti ? option : option.selectedOptions || [];

    this.setState(prevState => ({
      contentRecord: {
        ...prevState.contentRecord,
        [option.name]: optionValue,
      },
    }));
  };

  handleOnBack = () => {
    const { onCancel } = this.props;
    onCancel();
  }

  format = (canEdit, date = '') => {
    if (!date) {
      return '';
    }

    return canEdit ? dateISOFormat(date) : dateFormat(date);
  };

  form = ({
    canEdit, formDatas, contentRecord, profesoresMateria,
  }) => {
    // Prepara los datos para el formulario
    const mergedFormDatas = {
      ...formDatas,
      profesoresMateria,
    };
    if (formDatas.metodologias) {
      const selectedIds = new Set((contentRecord.metodologias || []).map(m => m.value));
      mergedFormDatas.metodologias = formDatas.metodologias.map(m => ({
        ...m,
        selected: selectedIds.has(m.value),
      }));
    }

    const initialValues = {
      ...contentRecord,
      fecha: this.format(canEdit, contentRecord.fecha),
    };

    // 2. Agrega los valores de "item" a initialValues para que redux-form los muestre
    if (contentRecord.metodologias) {
      contentRecord.metodologias.forEach((m) => {
        if (m.item) {
          initialValues[`metodologia_otro_${m.value}`] = m.item;
        }
      });

      initialValues.metodologias = contentRecord.metodologias.map(m => ({
        ...m,
        selected: true,
      }));
    }

    return (
      <ContentRecordForm
        {...initialValues}
        canEdit={canEdit}
        onSubmit={this.handleSubmit}
        onBack={this.handleOnBack}
        onChanges={this.handleChanges}
        onTextChanges={this.handleChangeText}
        onSelectChanges={this.handleChangeSelect}
        formDatas={mergedFormDatas}
      />
    );
  }

  render() {
    const { id, canEdit, profesoresMateria } = this.props;
    const {
      contentRecord,
      loaded,
      formDatas,
    } = this.state;

    const showLoading = !(loaded && formDatas) && !contentRecord;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nuevo'} Registros de Contenido
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              la informaci&oacute;n del Registros de Contenido
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ padding: '0' }}>
            {
              showLoading
                ? (<LoadingSpinner />)
                : this.form({
                  canEdit, formDatas, contentRecord, profesoresMateria,
                })
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

EditContentRecordContainer.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  subjectPeriodId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  profesoresMateria: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  canEdit: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default EditContentRecordContainer;
